export default __webpack_public_path__ + "static/media/model-registerstep.5abccbb1.png";